import React, {useCallback} from 'react';
import {NEW_RACK_CONFIGURATION} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import EffectDropdown from '../EffectDropdown.js';
import RoutingDropdown from './RoutingDropdown.js';

export default ({
    rack,
    routingNumber,
    sequencerEngine,
    setRoutingNumber,
    }) => {
        
        const newRouting = useCallback(() => {
            rack.newConfiguration();
        }, []);

        return (
            <Documented element={NEW_RACK_CONFIGURATION} className="rack-toolbar">
              <div onClick={newRouting}
                className="new-routing-button">
                New Routing
              </div>    
              <RoutingDropdown
                routingNumber={routingNumber}
                setRoutingNumber={setRoutingNumber}
                rack={rack}/>
            </Documented>
        );
};
